module.exports = __webpack_public_path__ + "img/indus-pic-12.14409c74.png";